<template>
  <div v-if="showBtn" :class="['dragBtn', 'dragBtn_' + position]" :style="dragBtnStyle" @mouseenter.stop="mouseenterEv" @mouseleave.stop="mouseleaveEv">
    <div
      :class="['dragBtn_inner', 'dragBtn_inner_' + position]"
      @mousedown.stop="mouseDownEv"
      :style="dragBtnInnerStyle"
    ></div>
    <span 
      v-if="isResizing && position === 'right'"
      :class="['size','size_+' + position]"
    >{{ Math.round(parseFloat(curColW)) }}%<span class="split-line">|</span>{{ Math.round(parseFloat(bortherW)) }}%</span>
    <span 
      v-if="isResizing && position === 'left'"
      :class="['size','size_+' + position]"
    >{{ Math.round(parseFloat(bortherW)) }}%<span class="split-line">|</span>{{ Math.round(parseFloat(curColW)) }}%</span>
  </div>
</template>

<script>
import { _throttle, findColPathByUid } from "utils"
import { CATEGORY_MODE } from "@/consts"
export default {
  props: {
    position: {
      type: String,
      required: true
    },
    zoom: {
      type: Number,
      default: 1
    },
    uid: {
      type: String,
      required: true
    },
    myid: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      path: null,
      mouseX: null,
      mouseY: null,
      handleMouseMoveCb: null,
      ctx: this,
      changeMouseStyle: false,
      curColW: null,
      bortherW: null,
      isResizing: false
    }
  },
  computed: {
    showBtn() {
      const useActiveIndex = this.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.options.activeIndex
      const activeRow = this.options.rows[useActiveIndex]
      const path = findColPathByUid(activeRow, this.uid)
      if (!path) return false
      return this.getRealUid(path) >= 0
    },
    dragBtnStyle() {
      let res = {
        "--resize": this.position === "left" || this.position === "right" ? "ew-resize" : "ns-resize"
      }
      switch (this.position) {
        case "left":
          this.setStyle(res, {
            top: "0px",
            left: "-4px",
            height: "100%",
            flexDirection: "row"
          })
          break
        case "right":
          this.setStyle(res, {
            top: "0px",
            right: "-4px",
            height: "100%",
            flexDirection: "row"
          })
          break
        case "top":
          this.setStyle(res, {
            top: "-4px",
            width: "100%",
            flexDirection: "column"
          })
          break
        case "bottom":
          this.setStyle(res, {
            bottom: "-4px",
            width: "100%",
            flexDirection: "column"
          })
          break

        default:
          break
      }
      return res
    },
    dragBtnInnerStyle() {
      let res = {
        backgroundColor: "var(--themeColor)"
      }
      switch (this.position) {
        case "left":
          this.setStyle(res, {
            width: "7px",
            height: "25px"
          })
          break
        case "right":
          this.setStyle(res, {
            width: "7px",
            height: "25px"
          })
          break
        case "bottom":
          this.setStyle(res, {
            width: "25px",
            height: "7px"
          })
          break
        case "top":
          this.setStyle(res, {
            width: "25px",
            height: "7px"
          })
          break

        default:
          break
      }
      return res
    }
  },
  methods: {
    setStyle(el, style) {
      for (let k in style) {
        el[k] = style[k]
      }
    },
    mouseDownEv(e) {
      //初始化当前鼠标位置
      this.mouseX = e.screenX / (this.zoom * 1.1)
      this.mouseY = e.screenY / (this.zoom * 1.1)
      this.changeMouseStyle = true
      window.localStorage.setItem("dragLayoutCol", true)
      const useActiveIndex = this.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.options.activeIndex
      const activeRow = this.options.rows[useActiveIndex]
      const path = findColPathByUid(activeRow, this.uid)
      const pathIndex = this.getRealUid(path)
      const data = {
        activeRow,
        path,
        pathIndex
      }
      //下面的属性获取用三元的原因是：
      //1.单例模式 只在当前拖拽周期的鼠标按下开始移动后的第一个瞬间计算一次 之后不用计算 节约性能
      //2. 有些属性需要在鼠标按下开始移动后的第一个瞬间给固定住
      this.handleMouseMoveCb = this.handleMouseMove.bind(this, data)
      window.addEventListener("mousemove", this.handleMouseMoveCb)
      window.addEventListener("mouseup", this.handleMouseUp)
    },
    handleMouseUp() {
      this.changeMouseStyle = false
      this.isResizing = false
      window.localStorage.removeItem("dragLayoutCol")
      window.removeEventListener("mousemove", this.handleMouseMoveCb)
      window.removeEventListener("mouseup", this.handleMouseUp)
    },
    handleMouseMove: _throttle(function (data, e) {
      if (this.position === "left" || this.position === "right") {
        this.handleXMove(data, e)
      } else {
        this.handleYMove(data, e)
      }
    }, 50),
    handleXMove(data, e) {
      this.isResizing = true
      //下面的属性获取用三元的原因是：
      //1.单例模式 只在当前拖拽周期的鼠标按下开始移动后的第一个瞬间计算一次 之后不用计算 节约性能
      //2. 有些属性需要在鼠标按下开始移动后的第一个瞬间给固定住
      const pathIndex = data.pathIndex
      //   pathIndex小于0，证明当前的这个左侧按钮是贴紧自由布局组件的，这时不需要做任何动作
      if (pathIndex < 0) return
      const path = data.path
      const col = data.hasOwnProperty("col") ? data.col : (data.col = path[pathIndex].cols[path[pathIndex].colId])
      const currElWidth = Number(
        data.hasOwnProperty("currElWidth")
          ? data.currElWidth
          : (data.currElWidth = document.getElementById(col.uid).offsetWidth)
      )
      const onePercentW = data.hasOwnProperty("onePercentW")
        ? data.onePercentW
        : (data.onePercentW = currElWidth / Number(col.width.slice(0, -1))) //百分之1的宽度的真实像素值
      //鼠标移动的距离
      const moveX = Number(e.screenX / (this.zoom * 1.1)) - this.mouseX
      //找到真正需要改宽度的col在path中的位置
      const curColW = data.hasOwnProperty("curColW") ? data.curColW : (data.curColW = Number(col.width.slice(0, -1)))
      const realBetweenCol = data.hasOwnProperty("realBetweenCol")
        ? data.realBetweenCol
        : path[pathIndex].cols[path[pathIndex].colId + (this.position === "left" ? -1 : 1)]
      const prevColW = data.hasOwnProperty("betweenColW")
        ? data.betweenColW
        : (data.betweenColW = Number(realBetweenCol.width.slice(0, -1)))
      const updatePercent = moveX / onePercentW //发生改变的百分比
      //拖拽后的百分比的值
      const newCurrPercent = curColW + (this.position === "left" ? -updatePercent : updatePercent) //经过减小的当前单元格的宽度
      const newPrevPercent = prevColW + (this.position === "left" ? updatePercent : -updatePercent) //经过增大的当前单元格前一个单元格的宽度
      if (newCurrPercent < 10 || newPrevPercent < 10) return
      this.$store.dispatch(this.request_prefix + "/changeRowColSize", {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        type: "width",
        col: col,
        val: newCurrPercent + "%"
      })
      this.$store.dispatch(this.request_prefix + "/changeRowColSize", {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        type: "width",
        col: realBetweenCol,
        val: newPrevPercent + "%"
      })
      this.curColW = newCurrPercent
      this.bortherW  = newPrevPercent
    },
    handleYMove(data, e) {
      //下面的属性获取用三元的原因是：
      //1.单例模式 只在当前拖拽周期的鼠标按下开始移动后的第一个瞬间计算一次 之后不用计算 节约性能
      //2. 有些属性需要在鼠标按下开始移动后的第一个瞬间给固定住
      const pathIndex = data.pathIndex
      //   pathIndex小于0，证明当前的这个左侧按钮是贴紧自由布局组件的，这时不需要做任何动作
      if (pathIndex < 0) return
      const path = data.path
      const row = data.hasOwnProperty("row") ? data.row : (data.row = path[pathIndex].rows[path[pathIndex].rowId])
      const col = data.hasOwnProperty("col") ? data.col : (data.col = path[pathIndex].cols[path[pathIndex].colId])
      const currElHeight = Number(
        data.hasOwnProperty("currElHeight")
          ? data.currElHeight
          : (data.currElHeight = document.getElementById(col.uid).parentNode.offsetHeight)
      )
      const onePercentH = data.hasOwnProperty("onePercentH")
        ? data.onePercentH
        : (data.onePercentH = currElHeight / Number(row.height.slice(0, -1))) //百分之1的宽度的真实像素值
      //鼠标移动的距离
      const moveY = Number(e.screenY / (this.zoom * 1.1)) - this.mouseY
      //找到真正需要改宽度的row在path中的位置
      const curRowH = data.hasOwnProperty("curRowH") ? data.curRowH : (data.curRowH = Number(row.height.slice(0, -1)))

      const realBetweenRow = data.hasOwnProperty("realBetweenRow")
        ? data.realBetweenRow
        : path[pathIndex].rows[path[pathIndex].rowId + (this.position === "top" ? -1 : 1)]
      const prevRowH = data.hasOwnProperty("betweenRowH")
        ? data.betweenRowH
        : (data.betweenRowH = Number(realBetweenRow.height.slice(0, -1)))
      const updatePercent = moveY / onePercentH //发生改变的百分比
      //拖拽后的百分比的值
      const newCurrPercent = curRowH + (this.position === "top" ? -updatePercent : updatePercent) //经过减小的当前单元格的宽度
      const newPrevPercent = prevRowH + (this.position === "top" ? updatePercent : -updatePercent) //经过增大的当前单元格前一个单元格的宽度
      if (newCurrPercent < 10 || newPrevPercent < 10) return
      this.$store.dispatch(this.request_prefix + "/changeRowColSize", {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        type: "height",
        row: row,
        val: newCurrPercent + "%"
      })
      this.$store.dispatch(this.request_prefix + "/changeRowColSize", {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        type: "height",
        row: realBetweenRow,
        val: newPrevPercent + "%"
      })
    },
    getRealUid(path) {
      let indexInPath = path.length - 1
      if (this.position === "left") {
        while (indexInPath >= 0) {
          if (path[indexInPath].colId === 0) {
            indexInPath--
          } else break
        }
        return indexInPath
      } else if (this.position === "right") {
        while (indexInPath >= 0) {
          if (path[indexInPath].colId === path[indexInPath].cols.length - 1) {
            indexInPath--
          } else break
        }
        return indexInPath
      } else if (this.position === "top") {
        while (indexInPath >= 0) {
          if (path[indexInPath].rows.length < 2 || path[indexInPath].rowId === 0) {
            indexInPath--
          } else break
        }
        return indexInPath
      } else if (this.position === "bottom") {
        while (indexInPath >= 0) {
          if (path[indexInPath].rows.length < 2 || path[indexInPath].rowId === path[indexInPath].rows.length - 1) {
            indexInPath--
          } else break
        }
        return indexInPath
      }
    },
    mouseenterEv() {
      this.$emit("mouseenter")
    },
    mouseleaveEv() {
      this.$emit("mouseleave")
    },
  }
}
</script>

<style scoped>
.dragBtn {
  position: absolute;
  display: flex;
  align-items: center;
}
.dragBtn_inner {
  z-index: 999;
  border-radius: 12px;
}
.dragBtn_inner:hover {
  cursor: var(--resize);
}
.dragBtn .size {
  position: absolute;
  padding: 8px 12px;
  left: 0;
  top: -40px;
  transform: translateX(-50%);
  background-color: var(--tipsBgColor);
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  border-radius: 4px;
  word-break: keep-all;
  width: 100px;
  margin-left: 5px;
}
.dragBtn .size.is-bottom {
  top: 10px;
}
.dragBtn .size:before {
  display: block;
  content: "";
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: var(--tipsBgColor) transparent transparent;
}
.dragBtn .size.is-bottom:before {
  top: -12px;
  bottom: auto;
  border-color: transparent transparent var(--tipsBgColor);
}
.dragBtn .split-line {
  color: var(--alertBackGround);
  margin: 0 4px;
}
</style>